import './ProductCard.css';

import React from 'react';
import { fullImagePath, generateClassName } from '../../../b2b-common/helpers';
import { Box, Card, CardContent, CardHeader } from '@mui/material';

const ProductCard = ({ product, className = null, ...params }) => {

    return (
        <Card variant='outlined' className={generateClassName('product-card', '', className)}  {...params}>
            <Box className='product-card-is-enabled' bgcolor={product.productEnabled ? 'success.main' : 'error.main'}
                position={'absolute'} top={'15px'} right={'15px'}
                width={'15px'} height={'15px'} borderRadius={'50%'}
            />
            <CardHeader title={product.productName} className='product-card-header' />
            <CardContent className='product-card-content'>
                <Box className='product-card-image-container'
                    width={'120px'} height={'120px'}
                    boxSizing={'border-box'}
                    position={'relative'} borderRadius={'50%'} overflow={'hidden'}
                >
                    <img src={fullImagePath(product.imagePath)} alt={product.productName} className='product-card-image' />
                </Box>
                <Box className='product-card-description'
                    width={'calc(100% - 120px)'} height={'120px'}
                    overflow={'auto'} p={2} boxSizing={'border-box'}
                >
                    {product.productDescription}
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProductCard;